export class DateUtils {
  static generateYears = () => {
    const currentDate = new Date();
    const currentYear = currentDate.getFullYear();
    const YEARS_MAX_OFFSET = 100;
    const YEARS_MIN_OFFSET = 18;
    const years = [];

    for (let i = YEARS_MIN_OFFSET; i <= YEARS_MAX_OFFSET; i++) {
      const calcYear = currentYear - i;
      years.push({ value: calcYear.toString(), leftLabel: calcYear.toString() });
    }

    return years;
  };

  static getDaysByMonth = (month: number, year: number) => new Date(year, month, 0).getDate();

  static generateDays = (month: { leftLabel: string; value: string }, year?: { leftLabel: string; value: string }) => {
    const days = [];

    if (!month?.value) {
      for (let i = 1; i <= 31; i++) days.push({ value: ('0' + i).slice(-2), leftLabel: ('0' + i).slice(-2) });
      return days;
    }
    const currentYear = new Date().getFullYear().toString();
    const yearValue = year?.value || currentYear;
    const daysInMonth = month?.value ? this.getDaysByMonth(month.value as unknown as number, yearValue as unknown as number) : 31;
    for (let i = 1; i <= daysInMonth; i++) days.push({ value: ('0' + i).slice(-2), leftLabel: ('0' + i).slice(-2) });

    return days;
  };
}
